import { useHost } from 'vue';
import type { AxCardPaymentEventMap } from '@/types';

type EventDetail<K extends keyof AxCardPaymentEventMap> =
  AxCardPaymentEventMap[K] extends CustomEvent<infer D> ? (D extends undefined ? [] : [D]) : never;

/** Dispatches typed DOM events on the <ax-card-payment> element for the merchant to listen to. */
export function useHostEvents() {
  const host = useHost();

  function dispatch<K extends keyof AxCardPaymentEventMap>(type: K, ...[detail]: EventDetail<K>): void {
    // Not bubbling on purpose: an `error` event reaching `window` would be picked up by global error trackers.
    host?.dispatchEvent(new CustomEvent(type, { detail }));
  }

  return { dispatch };
}
